import navClasses from "../../../css/modules/navigation.module.scss";
import { Link } from "react-router-dom";
import { routes } from "../../../utils/constants";
import clsx from "clsx";
import { NewProjectBtn } from "./NewProjectBtn";
import { Search } from "./Search";
import { Access } from "../../../components/Access";
import { AccessEntries, FEATURE_ACCESS } from "../../../utils/accessEntries";
import { SyncAllProjects } from "../../../components/SyncAllProjects";
import { HelpButton } from "../../../components/HelpButton";

export function ProjectsHeader() {
  return (
    <header className={clsx(navClasses.header, navClasses.projectsHeader)}>
      <div className={navClasses.container}>
        <Link to={routes.projects} className={navClasses.headerTitle}>
          <img src={"/logo.jpg"} alt="Logo" height="29" />
        </Link>
        <Access entry={AccessEntries.ImportProject} accessValues={FEATURE_ACCESS.Enabled}>
          <NewProjectBtn />
        </Access>
        <SyncAllProjects />
        <Search />
      </div>
      <HelpButton/>
    </header>
  );
}
